import { Breadcrumbs } from "../../../../../../../../constant/Breadcrumbs"
import { Routers } from "../../../../../../../../constant/Routers"

const { SCR222 } = Routers
const { BRCR_SCR222, BRCR_SCR222_USER } = Breadcrumbs

export const getBreadcrumbItems = (pathname: string) =>
  pathname === SCR222 ? BRCR_SCR222 : BRCR_SCR222_USER
